import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

class IframeBlot extends BlockEmbed {
  static blotName = 'iframe';
  static className = 'ql-iframe-embed';
  static tagName = 'DIV';

  static create(value) {
    const node = super.create();

    let src = (value?.iframe || '').trim();
    if (src && !src.startsWith('http://') && !src.startsWith('https://')) {
      src = 'https://' + src;
    }

    const aspectW = Number(value?.aspectW ?? 16);
    const aspectH = Number(value?.aspectH ?? 9);

    // wrapper ratio
    const wrapper = document.createElement('div');
    wrapper.className = 'ql-iframe-wrapper';
    wrapper.dataset.aspectW = String(aspectW);
    wrapper.dataset.aspectH = String(aspectH);
    wrapper.style.setProperty('--fb-aspect-w', aspectW);
    wrapper.style.setProperty('--fb-aspect-h', aspectH);

    // iframe réelle
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute(
      'style',
      'display: block; width: 100%; overflow: auto; margin: auto; border-width: 0px'
    );

    wrapper.appendChild(iframe);
    node.appendChild(wrapper);
    node.setAttribute('contenteditable', 'false');

    return node;
  }

  static value(node) {
    const wrapper = node.querySelector('.ql-iframe-wrapper');
    const iframe = node.querySelector('iframe');

    const aspectW = Number(wrapper?.dataset.aspectW || 16);
    const aspectH = Number(wrapper?.dataset.aspectH || 9);
    const src = iframe?.getAttribute('src') || '';

    return {
      iframe: src,
      aspectW,
      aspectH,
    };
  }
}

Quill.register(IframeBlot);

export default IframeBlot;